import { EnemyConfig } from "../../GameConfig/EnemyConfig.js";
import Burst from "../burst.js";

export default class DreadNoughtBurst extends Burst {
  constructor() {
    super();

    this.spriteWidth = EnemyConfig.DreadNought.BURST.SPRITE_WIDTH;
    this.spriteHeight = EnemyConfig.DreadNought.BURST.SPRITE_HEIGHT;

    this.image.src = EnemyConfig.DreadNought.BURST.IMG_SRC;
    this.maxFrame = EnemyConfig.DreadNought.BURST.MAX_FRAME;
  }
}
